export default {
  v3_00: '3.00',
  v3_10: '3.10'
}
